<template>
  <v-footer class="transparent pa-3 black--text font-weight-light footer-light" height="50">


    <div>&copy; {{ new Date().getFullYear() }} - Lingo AV </div>
    <v-spacer></v-spacer>
    <router-link to="/terms" target="_blank" class="ml-2 mr-2 black--text">Terms of Service</router-link>
    <router-link to="/legal" target="_blank" class="ml-2 mr-2 black--text">Privacy Policy</router-link>
    <router-link to="/cookiePolicy" target="_blank" class="ml-2 mr-2 black--text">Cookie Policy</router-link>
  </v-footer>

</template>

<style scoped>

a {
	text-decoration:none;
}

</style>

<script>
export default {
  name: 'lingo_footer_light',
  data() {
    return {

    };
  }
}
</script>
